import { TranslationService } from "../../../services/TranslationService";
import { ProfileData } from "./ProfileData";
import { usePreviousVersion } from "../../../hooks/usePreviousVersion";

export const DataPersonal = () => {
  const previousVersion = usePreviousVersion();

  return (
    <div className="main-layout-container mx-3">
      <div className="main-panel">
        <ProfileData />

        {previousVersion.allowed && (
          <div className="card mt-4">
            <div className="d-flex justify-content-end gap-5 align align-items-center">
              <div
                onClick={previousVersion.goToPreviousVersion}
                className="d-flex align-items-center pointer"
              >
                <i className="far fa-clock menu-item-icon"></i>
                <p className="menu-item-icon-text">
                  {TranslationService.translate.BackToV1}
                </p>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
